import React from "react";

const FormField = ({
  containerClass,
  id,
  label,
  required,
  type,
  autoComplete,
  placeholder,
  value,
}) => {
  return (
    <div className={containerClass}>
      {type !== "radio" && (
        <label htmlFor={id} className="block font-bold text-sm mb-1">
          {label}
          {required && <span className="text-teal">*</span>}
        </label>
      )}

      {type === "radio" && (
        <>
          <label className="block font-bold text-sm">
            <input
              type={type}
              name="Who are you looking to support?"
              id={id}
              required={required ? true : false}
              defaultValue={value ? value : ""}
              className="focus:ring-transparent focus:border-teal active:bg-teal checked:!bg-teal border-gray-200 mr-1"
            />
            {label}
            {required && <span className="text-teal">*</span>}
          </label>
        </>
      )}
      {type === "text" && (
        <input
          type={type}
          name={id}
          id={id}
          required={required ? true : false}
          autoComplete={autoComplete}
          placeholder={placeholder}
          defaultValue={value ? value : ""}
          className="py-3 px-4 block w-full placeholder-gray-300 text-sm rounded-md focus:ring-transparent focus:border-teal border-gray-200"
        />
      )}
      {type === "number" && (
        <input
          type={type}
          name={id}
          id={id}
          required={required ? true : false}
          autoComplete={autoComplete}
          placeholder={placeholder}
          defaultValue={value ? value : ""}
          className="py-3 px-4 block w-full placeholder-gray-300 text-sm rounded-md focus:ring-transparent focus:border-teal border-gray-200"
        />
      )}
      {type === "email" && (
        <input
          type={type}
          name={id}
          id={id}
          required={required ? true : false}
          autoComplete={autoComplete}
          placeholder={placeholder}
          defaultValue={value ? value : ""}
          className="py-3 px-4 block w-full placeholder-gray-300 text-sm rounded-md focus:ring-transparent focus:border-teal border-gray-200"
        />
      )}
      {type === "textarea" && (
        <textarea
          id={id}
          name={id}
          rows={8}
          placeholder={placeholder}
          className="py-3 px-4 block w-full placeholder-gray-300 text-sm rounded-md focus:ring-transparent focus:border-teal border-gray-200"
          defaultValue={value ? value : ""}
        />
      )}
    </div>
  );
};

export default FormField;
